// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+21qF","title":"styles_title__AlIFx","container":"styles_container__m433H","value":"styles_value__PJe+g"};